import { routes, type ProductKey } from '../site';

/**
 * Tüm Ürünler sayfası (/ozellikler; menüdeki "Ürünler" başlığının adresi). Metinler 30 Ekim içerik revizesinin
 * "Tüm Ürünler" artboard'undan. Kartın adı, rengi, ikonu ve adresi `productMeta`'dan gelir; burada yalnız kart metni
 * ve paket etiketi durur. Paket etiketi metindir (fiyat sayfasındaki paket verisinden türetilmez): ürün eklendiğinde
 * ya da paket içeriği değiştiğinde burası da güncellenir.
 */
export type PlanTone = 'all' | 'ai' | 'top' | 'beta';

export const urunlerPage = {
  href: routes.ozellikler.root,
  hero: {
    crumb: 'Ürünler',
    title: 'Bir platform,',
    titleAccent: 'tüm finansal kontrol.',
    lead: 'ZHesap mevcut sistemlerini değiştirmez; onların üzerine bir kontrol ve kârlılık katmanı olarak oturur. Bağlanır, kontrol eder, bir şey bulunca seni uyarır.',
  },
  inspect: 'İncele →',
  items: [
    {
      id: 'finans',
      plan: { label: 'Tüm paketlerde', tone: 'all' },
      title: 'Kargo faturanı ve hakedişini kuruşu kuruşuna kontrol et.',
      desc: 'Desi farkı, mükerrer fatura, eksik hakediş ve hatalı komisyonu sipariş bazında bulur. Fark belgelenir, tazmin ettirilir.',
    },
    {
      id: 'kampanya',
      name: 'Kampanya Kârlılığı & Sihirbazı',
      plan: { label: 'Tüm paketlerde', tone: 'all' },
      title: 'Kârlı kampanyalara otomatik katıl, satışını büyüt.',
      desc: 'Trendyol’un 6 kampanya kurgusu tek ekranda. Kârlı ürünler otomatik katılır, zarar ettirecekler dışarıda kalır.',
    },
    {
      id: 'ai',
      plan: { label: 'Scale · Signature · Sınırsız', tone: 'ai' },
      title: 'Müşteri sorusu beklemez, satış kaçmaz.',
      desc: 'Pazaryeri sorularına saniyeler içinde yanıt. Onaylı ya da otomatik mod, tek gelen kutusu, kişisel veriler maskelenir.',
    },
    {
      id: 'karlilik',
      plan: { label: 'Tüm paketlerde', tone: 'all' },
      title: 'Ciroyu değil, cebinde kalanı gör.',
      desc: 'Maliyet, komisyon, kargo, kupon, stopaj ve iade düşülmüş net kâr; sipariş, ürün, marka, kategori ve kanal bazında.',
    },
    {
      id: 'stok',
      plan: { label: 'Tüm paketlerde', tone: 'all' },
      title: 'Rafta bekleyen parayı görünür kıl.',
      desc: 'Tükenmek üzere, kritik ve hareketsiz ürünler; bağlı sermaye ve ne zaman ne kadar sipariş verileceği.',
    },
    {
      id: 'uyari',
      plan: { label: 'Tüm paketlerde', tone: 'all' },
      title: 'Sorunu ay sonunda değil, oluştuğu an öğren.',
      desc: 'Zararına satış, düşen marj, eksik maliyet. Her sabah özet rapor; push bildirim, e-posta ya da WhatsApp ile.',
    },
    {
      id: 'eklenti',
      plan: { label: 'Tüm paketlerde', tone: 'all' },
      title: 'Pazaryeri panelinden çıkmadan gerçek kârını gör.',
      desc: 'Trendyol, Hepsiburada, n11 ve Boyner panellerinde siparişlerine, promosyon ekranlarına ve ürün listene ZHesap’ın kâr hesabı eklenir.',
    },
    {
      id: 'rakip',
      plan: { label: 'Signature', tone: 'top' },
      title: 'Rakibin hamlesini ilk sen gör.',
      desc: '10 rakip ve 50 üründe fiyat, stok, kampanya ve BuyBox değişimleri; kârı koruyarak inilebilecek fiyat.',
    },
    {
      id: 'zeki',
      plan: { label: 'Beta', tone: 'beta' },
      title: 'İşletmenin en akıllı çalışanı.',
      desc: '“Geçen ay neden kârım düştü?” diye sor; nedenini ve alman gereken aksiyonu söylesin.',
    },
  ] as { id: ProductKey; name?: string; plan: { label: string; tone: PlanTone }; title: string; desc: string }[],
  soon: {
    label: 'Yakında',
    items: [
      { title: 'Omnichannel', desc: 'Fiziksel mağaza, e-ticaret ve pazaryeri aynı kârlılık tablosunda.' },
      { title: 'Mobil uygulama', desc: 'Özet raporlar ve uyarılar cebinde.' },
    ],
  },
  cta: {
    title: 'Hangisinin sana yaradığını',
    titleAccent: 'kendi verinle gör.',
    desc: 'Mağazanı ekibimiz bağlar, 7 gün boyunca kendi verinle ücretsiz kullanırsın.',
    button: { label: '7 Gün Ücretsiz Dene', href: '/#erken-erisim' },
  },
};
